import { useEffect, useState } from 'react';
import { connect } from 'redux-bundler-react';

import FileInput from '@components/file-input/FileInput';

import { useFormContext } from 'react-hook-form';

import { FileTypes } from '@src/utils/enums';
import { QUESTION_TYPE } from '../ddf.validation';
import { useRequest } from '@stores';

const DdfFileInput = connect(
  'doDeleteFile',
  'doDownloadFile',
  'doResetJPAFiles',
  'doUpdateSelectedFiles',
  'selectJpaFiles',
  ({
    doDeleteFile,
    doDownloadFile,
    doResetJPAFiles,
    doUpdateSelectedFiles,
    jpaFiles,
    componentId,
    fileDownload,
    formId,
    name,
    label,
    onChange = () => {},
    onChangeProps,
    tooltip,
    questionData,
  }) => {
    const { isRequired, jpaQuestionID, jpaSectionID } = questionData;

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileErrors, setFileErrors] = useState(false);
    const isSelectedFiles = selectedFiles?.length > 0;
    const questionFiles = jpaFiles.filter((item) => Number(item.jpaQuestionID) === Number(jpaQuestionID));
    const isS3File = questionFiles.filter((item) => item?.isUploadedToS3).length > 0;

    const isReadOnly = useRequest((state) => state.isFormReadOnly);
    const { setValue, watch, trigger } = useFormContext();

    const handleFileInput = (e) => {
      //Only continue if a file has been selected
      if (e.target.files && e.target.files.length > 0) {
        const filesArr = Array.from(e?.target?.files) ?? [];
        setSelectedFiles(filesArr);
        onChange?.(true, jpaQuestionID, QUESTION_TYPE.file, formId, onChangeProps);
        trigger(name);
      } else {
        onChange?.(false, jpaQuestionID, QUESTION_TYPE.file, formId, onChangeProps);
      }
    };

    const handleDeleteFile = () => {
      isS3File && questionFiles.forEach((item) => doDeleteFile(item.fileName, componentId));
      doResetJPAFiles(jpaQuestionID);
      setSelectedFiles([]);
      // Update RHF values object
      setValue(name, [], { shouldValidate: true });
      // Update JPA answerSet object
      onChange?.(false, jpaQuestionID, QUESTION_TYPE.file, formId, onChangeProps);
    };

    // Download file(s) from S3
    const handleDownloadFile = () => {
      isS3File && questionFiles.forEach((item) => doDownloadFile(item.fileName, FileTypes.Request));
    };

    // Update Redux Store files list with JPA staged files
    useEffect(() => {
      if (isSelectedFiles) {
        const doSelectFile = () => {
          selectedFiles.forEach((item) => {
            const fileTags = {
              componentID: componentId,
              file: item,
              fileName: item?.name,
              isInvalid: fileErrors === true,
              jpaFormID: formId,
              jpaSectionID: jpaSectionID,
              jpaQuestionID: jpaQuestionID,
              jpaQuestionTypeID: QUESTION_TYPE.file,
              section: 'JPA',
            };
            doUpdateSelectedFiles(fileTags);
          });
        };

        doResetJPAFiles(jpaQuestionID);
        doSelectFile();
      }
    }, [
      doResetJPAFiles,
      doUpdateSelectedFiles,
      componentId,
      fileErrors,
      isSelectedFiles,
      formId,
      jpaQuestionID,
      jpaSectionID,
      selectedFiles,
    ]);

    useEffect(() => {
      if (fileErrors) {
        setValue(name, [], { shouldValidate: true });
        trigger(name);
      }
    }, [fileErrors, name, setValue, trigger]);

    // EDGE CASE: Retrieving S3 files and syncing hasJPAFileUploaded value
    // User deleted files but did not save request
    useEffect(() => {
      if (questionFiles.length === 0 && watch(name) === true) {
        onChange?.(false, jpaQuestionID, QUESTION_TYPE.file, formId, onChangeProps);
        setValue(name, false, { shouldValidate: true });
      }
      if (questionFiles.length > 0 && watch(name) !== true && isS3File) {
        onChange?.(true, jpaQuestionID, QUESTION_TYPE.file, formId, onChangeProps);
        setValue(name, true, { shouldValidate: true });
      }
    }, [isS3File, name, formId, jpaQuestionID, onChange, onChangeProps, questionFiles, setValue, watch]);

    return (
      <FileInput
        downloadFileCallback={() => handleDownloadFile()}
        deleteFileCallback={() => handleDeleteFile()}
        fileDownload={fileDownload}
        id={name}
        label={label}
        multiple={true}
        name={name}
        onChangeCallback={handleFileInput}
        readOnly={isReadOnly || isS3File}
        required={isRequired}
        resetFileErrors={!fileErrors}
        setFileErrors={setFileErrors}
        showDownloadButton={isS3File}
        showDeleteButton={isS3File && !isReadOnly}
        tooltip={tooltip}
        value={questionFiles}
      />
    );
  }
);

export default DdfFileInput;
